import type { Identifier } from "ra-core";
import { useGetManyAggregate } from "ra-core";

export const useGetSalesName = (
  id?: Identifier,
  options?: { enabled?: boolean },
) => {
  const enabled = options?.enabled ?? id != null;
  const { data, error } = useGetManyAggregate(
    "sales",
    { ids: id !== null ? [id] : undefined },
    { enabled },
  );

  // useGetManyAggregate returns [] (truthy) when the id resolves to no sales
  // row — disabled, deleted, or never matched (common with imported records).
  // Guard data[0], not just data, or `.first_name` throws during render.
  return data?.[0]
    ? `${data[0].first_name} ${data[0].last_name}`
    : error
      ? "??"
      : "";
};
